import { BLOCK_MATH_PATTERN, INLINE_MATH_PATTERN } from './math.util';

const MATH_REGEX = new RegExp(`${BLOCK_MATH_PATTERN}|${INLINE_MATH_PATTERN}`, 'g');

/**
 * Escapes tildes inside math expressions to prevent markdown strikethrough interpretation.
 * The tildes are converted to HTML entity &#126; which is restored by the math processor.
 */
export function escapeTildesInMath(markdown: string): string {
  return markdown.replace(MATH_REGEX, (match, blockMath?: string, inlineMath?: string) => {
    const content = (blockMath ?? inlineMath ?? '').replace(/~/g, '&#126;');
    return blockMath !== undefined ? `$$${content}$$` : `$${content}$`;
  });
}

/**
 * Restores escaped tildes (&#126;) back to ~ for KaTeX rendering
 */
export const unescapeTildes = (value: string): string => value.replaceAll('&#126;', '~');
